import { Draft } from '@reduxjs/toolkit';

import { IWorkerData } from '../../initialState';

function getAllFailure(draft: Draft<IWorkerData>) {
  draft.getAll.config.isLoading = false;
  draft.getAll.config.errorMsg = 'Failed to get Workers';
}

export default getAllFailure;
